import React, { Component } from 'react';

import Analytics from 'APP_ROOT/services/analytics';
import CognitoUtil from '../../aws/cognito/cognitoUtil';
import HistoryUtil from '../../common/historyUtil';
import { strings } from '../../../localization';
import ProgressOverlay from '../../common/ProgressOverlay';
import PasswordPolicyChecklist from '../../common/passwordPolicyChecklist';

function getErrorMessage(error){
    if(error.code === 'UserNotFoundException'){
        return strings.formatString(strings.forgot_pw_user_not_found);
    }
    if(error.code === 'CodeMismatchException'){
        return strings.formatString(strings.forgot_pw_verification_code_invalid);
    }
    if(error.code === 'ExpiredCodeException'){
        return strings.formatString(strings.forgot_pw_verification_code_expired);
    }
    if(error.code === 'InvalidPasswordException'){
        return strings.formatString(strings.forgot_pw_password_invalid);
    }

    return strings.formatString(strings.forgot_pw_generic_error);

}


export default class ForgotPasswordPage extends Component {

    constructor(props) {

        super(props);
        this.state = {
            email: '',
            error: null,
            verify: false,
            verificationCode: '',
            newPassword: '',
            isNewPasswordValid: false
        }
    }

    componentDidMount() {
        Analytics.pageView();
    }

    cleanString = (str) => {
        return str.replace(/[\s]/g, '');
    }

    // Input[type="email"] automatically sends clean string to onInput/onChange so even though there are spaces in the textbox
    // they are not passed to state, therefore state doesn't update (and no rerender happens). And as a result, spaces remain in the textbox
    // so we need to prevent spaces from being entered in the first place
    onKeyPress = (e) => {
        if (e.keyCode === 32) {
            e.preventDefault();
        }
    }

    onInputChange = (e, propertyName) => {
        const cleanedString = this.cleanString(e.target.value);

        var state = this.state;
        state[propertyName] = cleanedString;
        this.setState(state);
    }

    onResetSubmit = (e) => {

        e.preventDefault();
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (!re.test(this.state.email)) {
            this.setState({
                error: strings.formatString(strings.forgot_pw_email_invalid)
            });
            return;
        } else {
            console.log('forgot password email sent');
            CognitoUtil.forgotPassword(this.state.email, this.onResetSuccess, this.onResetFailure);
        }
    }

    onResetSuccess = (result) => {

        this.setState({
            verify: true,
            error: null
        });
    }

    onResetFailure = (err) => {

        this.setState({
            error: getErrorMessage(err)
        });
    }

    onConfirmSubmit = (e) => {

        e.preventDefault();

        this.setState({
            loading: true,            
            error: null,
        });

        CognitoUtil.confirmPassword(this.state.verificationCode, this.state.newPassword, this.onConfirmSuccess, this.onConfirmFailure);
    }

    onConfirmSuccess = (result) => {
        HistoryUtil.push('/');
    }

    onConfirmFailure = (err) => {
        this.setState({
            loading: false,
            error: getErrorMessage(err),
        });
    }

    render() {

        if (!this.state.verify) {
            return (
                <div className="container forgot-password-page">
                    <div className="row">
                        <div className="col-12 col-md-8 col-lg-6">
                            <h1>{strings.formatString(strings.forgot_pw_title)}</h1>
                            <p>{strings.formatString(strings.forgot_pw_m1)}</p>
                            <p>{strings.formatString(strings.forgot_pw_m)}</p>
                            <form onSubmit={this.onResetSubmit}>
                                <input type="email" name="resetPasswordEmail" placeholder="eg.yourname@email.com" value={this.state.email} onKeyDown={this.onKeyPress} onChange={(e) => this.onInputChange(e, 'email')} />
                                <input type="submit" className="btn" value={strings.input_submit_name} disabled={this.state.email.length <= 0} />
                                {this.state.error ? <p className="red">{this.state.error.toString()}</p> : null}
                            </form>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="container forgot-password-page">
                    <div className="row">
                        <div className="col-12 col-md-8 col-lg-6">
                            <h1>{strings.formatString(strings.forgot_pw_verficiation_m)}</h1>
                            <p className='blue pb-3'>{strings.formatString(strings.forgot_pw_instructions_m, this.state.email)}</p>
                            <form onSubmit={this.onConfirmSubmit}>
                                <label htmlFor="verificationCode">{strings.formatString(strings.verify_account_code)}</label>
                                <input type="text" name="verificationCode" autoComplete="verification code" value={this.state.verificationCode} onChange={(e) => this.onInputChange(e, 'verificationCode')} />
                                <label htmlFor="newPassword">{strings.formatString(strings.password_new_title)}</label>
                                <input type="password" name="newPassword" autoComplete="new-password" value={this.state.newPassword} onChange={(e) => this.onInputChange(e, 'newPassword')} />
                                <input type="submit" className="btn" value={strings.input_submit_name} disabled={!this.state.isNewPasswordValid || this.state.verificationCode.length <= 0} />
                                {this.state.error ? <p className="red">{this.state.error.toString()}</p> : null}
                                <div className='mt-5'>
                                    <PasswordPolicyChecklist password={this.state.newPassword} onPolicyCheck={(result) => { if(result !== this.state.isNewPasswordValid) this.setState({isNewPasswordValid: result})}} />
                                </div>

                            </form>
                            {this.state.loading ? <ProgressOverlay /> : null}
                        </div>
                    </div>
                </div>
            );
        }
    }
}
